import { images } from "utils/images"
import { maxWidth950Landscape, maxHeight700 } from "themes/default/breakpoints"

export const styles = {
  container: {
    backgroundImage: `url(${images.studentBg})`,
    backgroundSize: "100% 100%",
    backgroundPosition: "center center",
    backgroundRepeat: "no-repeat",
    width: "100%",
    minHeight: "100vh",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    position: "relative",
    [maxWidth950Landscape]: {
      justifyContent: "flex-start",
    },
    [maxHeight700]: {
      justifyContent: "flex-start",
    },
  },
}
